module.exports = __webpack_public_path__ + "img/302.b2d18f1f.png";